let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("isGPI")).then(() => parcelRequire('8MfT0'));